export const CHANNEL_LABELS = {
  wallet_recharge: 'Wallet Recharge',
  booking_advance: 'Booking Advance',
  refund: 'Refund',
  general: 'General',
};

export const STATUS_LABELS = {
  captured: 'Captured',
  failed: 'Failed',
  reversed: 'Reversed',
};

export function formatReconDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatReconDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

export function formatInr(amount) {
  const n = Number(amount || 0);
  return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

export function formatInrPlain(amount) {
  const n = Number(amount || 0);
  return n.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 0 });
}

export function channelLabel(channel) {
  return CHANNEL_LABELS[channel] || channel || 'General';
}

export function statusLabel(status) {
  return STATUS_LABELS[status] || status || 'Captured';
}

export function cleanDescription(desc = '') {
  return String(desc)
    .replace(/\[[^\]]*\]/gi, '')
    .replace(/\s+/g, ' ')
    .trim() || '—';
}
